import { useNavigate } from "react-router-dom";
import ArrowIco from "../../../../assets/careerBuddy/arrow_ic.svg";
import ShineIco from "../../../../assets/strength/ic_shine.svg";
import ActivityIco from "../../../../assets/strength/ic_activity.svg";
import DoWellIco from "../../../../assets/strength/ic_do_well.svg";
import LightBulbIco from "../../../../assets/strength/ic_light_bulb.png";
import strengthsActiveIcon from "../../../../assets/ic_strengths_active.svg";
import "./style.scss";
import remarkGfm from "remark-gfm";
import Slider from "react-slick";
import { useEffect, useRef, useState } from "react";
import { initStrengths } from "../../../../redux/actions";
import ReactMarkdown from "react-markdown";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../components/Loader";
const slidersettings = {
    dots: true,
    infinite: true,
    arrows: false,
    autoPlay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
};
export default function Strengths() {
    const { strengths, isLoader } = useSelector((state) => state.strengthsReducer);
    const router = useNavigate();
    const dispatch = useDispatch();
    const hitOnetime = useRef(false);
    const slidesRef = useRef([]);
    const StrengthSlider = ({ data, startIndex }) => {
        return <div className="w-100"><Slider ref={(el) => (slidesRef.current[startIndex] = el)} {...slidersettings}>
            {data.map((item, index) => (
                <StrengthCard item={item} />
            ))}
        </Slider>
        </div>
    };

    const handleSeeMore = (index) => {
        slidesRef.current[index]?.slickNext();
    }
    useEffect(() => {
        if (!hitOnetime.current) {
            dispatch(initStrengths());
            hitOnetime.current = true;
        }
    }, [dispatch]);
    const lists = {
        Shine: [
            { title: "Where You Shine", list: strengths?.top_traits },
            { text: strengths?.traits_insights },
            {
                head: "Choose one and try leaning on it when you face a challenge. Notice what happens.",
                icon: LightBulbIco
            }
        ],
        DoWell: [
            { title: "Things You Do Well", list: strengths?.top_skills },
            { text: strengths?.skills_insights },
            {
                head: "How could these help with something you’re working on? Challenge yourself to notice when you use it.",
                icon: LightBulbIco
            }
        ],
        Activity: [
            { title: "Activities You Enjoy", list: strengths?.top_activities },
            { text: strengths?.activities_insights },
            {
                head: "Think about how you’ve already been using these. Where did it make a difference?",
                icon: LightBulbIco
            }
        ],
    };
    const isEmpty =
  Object.entries(strengths).every(([key, value]) => {
    if (key === "first_name") return true; // skip first_name
    return (
      value === "" ||
      (Array.isArray(value) && value.length === 0) ||
      value == null
    );
  });
  console.log(isEmpty,'isEmpty==');
    return <div className="aiCompanions__container strengths">
        <div className="aiCompanions__backScoop">
            <button onClick={() => router(-1)}>
                <img src={ArrowIco} alt="back" /> Back
            </button>
        </div>
        <div className="aiCompanions__title">
            <h3>Strengths</h3>
            <p>{strengths?.first_name || 'User'}, these are the qualities that make you stand out.</p>
        </div>
        {
            isLoader ? <Loader /> :
                !isEmpty ?
                    <>
                        <div className="strengths__row">
                            <div className="strengths__lists">
                                <div className="w-100 strengths__lists__card">
                                    <img src={ShineIco} alt="Shine" className="strengths__lists__icon" height={74} />
                                    <StrengthSlider data={lists.Shine} startIndex={0} />
                                </div>
                                <button className="strengths__btn" button='button' onClick={() => handleSeeMore(0)}>See More</button>
                            </div>
                            <div className="strengths__lists">
                                <div className="w-100 strengths__lists__card">
                                    <img src={DoWellIco} alt="Do Well" className="strengths__lists__icon" height={74} />
                                    <StrengthSlider data={lists.DoWell} startIndex={1} />
                                </div>
                                <button className="strengths__btn" button='button' onClick={() => handleSeeMore(1)}>See More</button>
                            </div>
                            <div className="strengths__lists">
                                <div className="w-100 strengths__lists__card">
                                    <img src={ActivityIco} alt="Do Well" className="strengths__lists__icon" height={74} />
                                    <StrengthSlider data={lists.Activity} startIndex={2} />
                                </div>
                                <button className="strengths__btn" button='button' onClick={() => handleSeeMore(2)}>See More</button>
                            </div>
                        </div>
                        <p className="strengths__title">Lean on your strengths — they’ll guide you forward <img src={strengthsActiveIcon} alt="strength" /></p>
                    </>
                    :
                    <div className="emptySessionHistotyCont">
                        <div className="emptySessionHistotyCont__emptArea">
                            <p className="emptySessionHistotyCont__emptArea__text">
                                Still loading your greatness… Come back soon!
                            </p>
                        </div>
                    </div>
        }
    </div>
}
const StrengthCard = ({ item, ref }) => {
    const { title, list, text, head, icon } = item
    const [expandedLi, setExpandedLi] = useState({});
    const toggleLi = (key) => {
        setExpandedLi((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };
    const dataText = text?.replace(/^"|"$/g, "");
    return <div className="strengths__list">
        {title && <h3>{title}</h3>}
        {list && <ul className="strengths__list__ul">
            {list.map((li, i) => {
                const key = `${title}-${i}`;
                const isExpanded = expandedLi[key];
                const shouldTruncate = li.length > 25;
                return <li
                    style={{
                        whiteSpace: isExpanded || !shouldTruncate ? "normal" : "nowrap",
                        overflow: isExpanded || !shouldTruncate ? "visible" : "hidden",
                        textOverflow: isExpanded || !shouldTruncate ? "clip" : "ellipsis",
                        cursor: shouldTruncate && !isExpanded ? "pointer" : "default",
                    }}
                    onClick={() => shouldTruncate && !isExpanded && toggleLi(key)}
                    title={!isExpanded && shouldTruncate ? "Click to expand" : ""}
                    key={i}
                >
                    {li}
                    {shouldTruncate && !isExpanded && (
                        <span>
                            ...
                        </span>
                    )}
                </li>
            })}
        </ul>}
        {text && <div className="strengths__list__des"><ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
                a: ({ node, ...props }) => (
                    <a
                        {...props}
                        target="_blank"
                        rel="noopener noreferrer"
                    />
                ),
            }}
        >
            {dataText}
        </ReactMarkdown></div>}
        {/* {text && <div className="strengths__list__des" ref={ref} dangerouslySetInnerHTML={{ __html: text }}></div>} */}
        {head && <h4>{head}</h4>}
        {icon && <img src={icon} className="strengths__list__ico" alt="Shine" height={74} />}
    </div>
}